<template>
  <collapsible-section class='_pt0 _pb0' :collapsed='false'>
    <template #headerText>
      <p class='color-leaf'>Personal Information</p>
    </template>
    <template #headerActions>
      <mail-id-cards
        @notificationToggled="isShowing => hideOtherButtons = isShowing"
      />
      <!--<print-id-cards />-->
      <id-card-download />
    </template>
    <template #collapsibleSection>
      <async-loader v-if='memberDetailsLoading'/>
      <div v-else container class='_ptxs _pbxs'>
        <div row class='_flex'>
          <labeled-data
            label="Group:"
            :data="
              `${memberDetails.member.groupName} - ${
                memberDetails.member.groupId
              }`"
          />

          <labeled-data
            label='EyeMed Member ID:'
            :data='memberDetails.member.eyemedMemberId'
          />

          <labeled-data
            v-if="!ssnMatchesClientHealthId(memberDetails.member.ssn, memberDetails.member.clientHealthId)"
            label="Client's Member ID:"
            :data='memberDetails.member.clientHealthId'
          />
          <labeled-data
            v-else
            label="Client's Member ID:"
            :data='maskedClientHealthId(memberDetails.member.ssn, memberDetails.member.clientHealthId)'
          />

          <labeled-data
            label="Member Status:"
            :data='memberDetails.member.memberStatus === "Y" ? "Active" : "Inactive"'
          />

        </div>
        <div row class='_flex'>
          <labeled-data label='First Name:' :data='memberDetails.member.firstName'/>
          <labeled-data label='Last Name:' :data='memberDetails.member.lastName'/>
          <labeled-data label='Date of Birth:' :data='formatDate(memberDetails.member.dateOfBirth)'/>
          <labeled-data label="Relationship:" :data="memberDetails.member.relationshipCodeText"/>
        </div>
        <div row class='_flex'>
          <labeled-data label='Gender:' :data='gender'/>
          <labeled-data label='SSN:' :data='"###-##-" + memberDetails.member.ssn.substr(-4)' v-if='memberDetails.member.ssn.trim()'/>
          <labeled-data label='SSN:' :data='memberDetails.member.ssn' v-else/>
          <labeled-data label='Network Name' :data='memberDetails.member.networkName' />
          <labeled-data label="Last ID Card Mailed:" :data="formatDate(memberDetails.member.cardMailDate)" v-if="memberDetails.member.memberType === 'Subscriber'"/>
          <labeled-data v-else />
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import CollapsibleSection from '@sections/CollapsibleSection'
  import memberManagement from '@mixins/memberManagement'
  import clientHealthId from '@mixins/clientHealthId'
  import formattable from '@mixins/formattable'
  import LabeledData from '@molecules/LabeledData'
  import MailIdCards from '../MemberPartials/MailIdCards'
  import IdCardDownload from '../MemberPartials/IdCardDownload'

  export default {
    mixins: [memberManagement, formattable, clientHealthId],
    components: {
      CollapsibleSection,
      LabeledData,
      MailIdCards,
      IdCardDownload
    },
    data() {
      return {
        hideOtherButtons: false
      }
    },
    computed: {
      gender() {
        if (this.memberDetails.member.gender === 'F') { return 'Female' } else if (this.memberDetails.member.gender === 'M') { return 'Male' } else { return 'Unknown' }
      }
    }
  }
</script>
